import isPropValid from '@emotion/is-prop-valid';
import styled from '@emotion/styled';

import { type Breakpoint, mq, spacing } from '@/lib/theme';

/** A 12-column grid. Columns say how many tracks they span at each breakpoint. */
export const Grid = styled.div`
	display: grid;
	grid-template-columns: repeat(12, minmax(0, 1fr));
	column-gap: ${spacing.space40};
	row-gap: ${spacing.space50};

	${mq.md} {
		column-gap: ${spacing.space50};
		row-gap: ${spacing.space60};
	}
`;

type Span = Partial<Record<Breakpoint | 'base', number>>;

const shouldForwardProp = (prop: string) =>
	isPropValid(prop) && prop !== 'span';

/**
 * `<Column span={{ base: 12, md: 7, xl: 8 }}>`: full width on phones, seven
 * columns from medium screens, eight from extra-large.
 */
export const Column = styled('div', { shouldForwardProp })<{ span?: Span }>`
	grid-column: span ${({ span }) => span?.base ?? 12};
	min-width: 0;

	${({ span }) =>
		(['sm', 'md', 'lg', 'xl', 'xxl'] as const)
			.filter((bp) => span?.[bp] !== undefined)
			.map((bp) => `${mq[bp]} { grid-column: span ${span?.[bp]}; }`)
			.join('\n')}
`;
